// @flow

import { location } from 'window';

import url from 'url';

import config from 'config';

import $ from 'jquery';
import _ from 'lodash';
import Q from 'q';

import 'ko-component-file-upload-input';
import 'ko-component-fio-input';
import 'ko-component-vehicle-maker-model-select';
import 'ko-component-office-select';
import 'ko-component-extended-address-editor';

import TraceKit from 'rgs-tracekit';
// import window from 'window';
import compareUtil from 'compare-util';
import { profile } from 'myrgs-auth-helpers';
import { Error } from 'error';

import server from 'server2';

import * as serverTime from 'observable-server-time';

import { allOfficeRegions as allOfficeRegionsDictionary} from 'rgs-dictionary';

import page from 'page-common';
import { ContentCalcLoading as ContextBarContentLoading } from 'context-bar';

import Dictionaries from './js/dictionaries.js';

import type { ControllerOptions } from './js/controller';
import Controller from './js/controller';

const VIEW_SELECTOR = '#calc-feedback-view';


function init () {
	TraceKit.notifications = true;

	const progressbar = new ContextBarContentLoading({
		visible: _.constant(true),
	});
	page.contextBar.add(progressbar);

	const domReady = Q.promise(resolve => $(resolve));

	const contextConfigReady = domReady
		.then(() => JSON.parse($('#calc-feedback-context').html()));

	const queryParamsReady = Q(url.parse(location.href, true).query);

	const extendedContextReady = Q.all([
		contextConfigReady,
		queryParamsReady,
	])
		.spread(async (context, query) => {
			context.key = query.key || undefined;

			if (query.token) {
				try {
					await server.my.cmsapi
						.post(['lk', 'auth', 'token'], {
							body: {
								Token: decodeURIComponent(query.token),
							},
						});
					await profile.update();

					const res = await server.my.rest
						.get(['lk', 'profiles', 'my', 'auxiliaryOrderData'], {
							query: {
								token: decodeURIComponent(query.token),
							},
						});
					const response = res && res.responseJSON && res.responseJSON.Data;

					context.key = (response && response.OrderKey) || query.key || undefined;
				} catch (error) {
					const errorText = error.response && error.response.responseJSON.StatusText;
					page.notifications.push({
						css: { 'notification-danger': true },
						message: errorText,
					});
					context.tokenError = errorText;
				}
			}
			const queryCategory = query.category || undefined;
			const contextCategory = context.category || undefined;

			context.category = contextCategory || queryCategory;

			context.isCategorySelectVisible = context.isCategorySelectVisible !== false;
	
			context.mode = context.tokenError ? undefined : (query.mode || undefined);

			return context;
		});

	const dictsReady = Q.all([
		allOfficeRegionsDictionary.ready(),
		server.any.api.get(['complaint', 'getThemedCategories']),
		server.any.api.get(['complaint', 'data']),
		server.any.api.get(['ekasko', 'kladr', 'extended', 'regions']),
	])
		.spread((
			regionsOld,
			{ responseJSON: { Data } },
			{ responseJSON: { Data: { Facility, WayAddressing, AccidentDamageKind } } },
			{ responseJSON: { Data: regions } },
		) => {

			const dictionaries = new Dictionaries;
			dictionaries.loadData({
				regions: regionsOld,
				categories: Data,
				facilityTypes: Facility,
				wayAddressingTypes: WayAddressing,
				accidentDamageKinds: AccidentDamageKind,
				kladrRegions: regions
			});

			return dictionaries;
		});

	const configReady = Q.all([
		config.cms.pageUrls.get(),
		config.cms.siteID.get(),
	])
		.spread((pageUrls, siteID) => {
			return { cms: { pageUrls, siteID } };
		});

	return Q.all([
		extendedContextReady,
		dictsReady,
		configReady,
		domReady,
		serverTime.ready(),
	])
		.then(([
			context,
			dictionaries,
			config,
		]) => {
			//eslint-disable-next-line max-len
			if (compareUtil.compareStringsCaseInsensitive(context.mode, dictionaries.calculatorMode.kbmCheck) && !context.key && !context.tokenError) {
				throw new Error(
					'Режим проверки КБМ должен содержать ключ/токен заказа');
			}

			const controllerOptions: ControllerOptions = {
				view: $(VIEW_SELECTOR)[0],
				context,
				dictionaries,
				config,
			};

			const calc = new Controller(controllerOptions);

			require('debug-globals').extend({calcFeedbackController: calc});
		})
		.catch((e: Error) => {
			$(VIEW_SELECTOR).hide();
			throw e;
		})
		.finally(() => {
			page.contextBar.remove(progressbar);
		})
		.done();
}

init();
